// helper functions specific to GC report generation...

import React from 'react';
import PpuListingTable from '../../static-components/global-commitment/ppu-listing-table';
import RmpNcpListingTable from '../../static-components/global-commitment/rmpncp-listing-table';
import RmpCpListingTable from '../../static-components/global-commitment/rmpcp-listing-table';
import SppiListingTable from '../../static-components/global-commitment/sppi-listing-table';
import CsrListingTable from '../../static-components/global-commitment/csr-listing-table';
import GovListingTable from '../../static-components/global-commitment/gov-listing-table';

import { generateGCReportUrl } from '../generate-url-functions';

export const generateGcDropdownLinks = (linkData, category, currentPage) => {
  // generate proper links for companies dropdown
  const gcDropdownLinks = [];
  for (let i = 0; i < linkData.length; i++) {
    const linkText = linkData[i].organisation_name__b_1;
    if (linkText !== currentPage) {
      const url = generateGCReportUrl(
        category,
        linkData[i].organisation_name__b_1,
        linkData[i].slug__b_4
      );
      const newArrayItem = { name: linkText, url: url };
      gcDropdownLinks.push(newArrayItem);
    }
  }
  return gcDropdownLinks;
};

export const switchCategoryTable = categoryCode => {
  switch (categoryCode) {
    case 'csr':
      return <CsrListingTable />;
    case 'gov':
      return <GovListingTable />;
    case 'rmpcp':
      return <RmpCpListingTable />;
    case 'rmpncp':
      return <RmpNcpListingTable />;
    case 'sppi':
      return <SppiListingTable />;
    default:
      return <PpuListingTable />;
  }
};

export const buildBarData = array => {
  const transformedData = [];
  array.forEach(object => {
    if (object.value && object.date) {
      transformedData.push({
        label: object.date ? object.date : '',
        value: object.value ? object.value : '',
        colour: object.colour ? object.colour : 'rgb(102,102,102, 0.5)',
      });
    }
  });
  return transformedData;
};

export const handleMissingMetrics = (weight, percentage) => {
  return weight || percentage ? weight + '/' + percentage + '%' : '-';
};
